import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";

export default class AddCareer extends Component {
  state = {
    job_title: "",
    job_location: "",
    job_type: "",
    job_category: "",
    job_description: "",
    salary_range: "",
    urgent_hiring: false,

    allCategories: [],
    notification: false,
    message: "",
    noticolor: "success",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getCareerCategories();
  }

  getCareerCategories = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAllCareerCategories)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({ allCategories: resp.data.data });
          }
        })
        .catch(() => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: "Error fetching categories",
          });
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const payload = {
      job_title: this.state.job_title,
      job_location: this.state.job_location,
      job_type: this.state.job_type,
      job_category: this.state.job_category,
      job_description: this.state.job_description,
      salary_range: this.state.salary_range,
      urgent_hiring: this.state.urgent_hiring,
    };

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createCareer, payload)
        .then((resp) => {
          this.setState({
            notification: true,
            noticolor: "success",
            message: resp.data.message,
            loading: false,
          });
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || "Something went wrong",
            loading: false,
          });
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/careers" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create Career
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      label="Job Title"
                      name="job_title"
                      fullWidth
                      required
                      onChange={this.handleInput}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Job Location"
                      name="job_location"
                      fullWidth
                      required
                      onChange={this.handleInput}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Job Type</InputLabel>
                    <Select
                      name="job_type"
                      fullWidth
                      required
                      value={this.state.job_type}
                      onChange={this.handleInput}
                      style={{height: "45px"}}
                    >
                      <MenuItem value="">Select Job Type</MenuItem>
                      <MenuItem value="full_time">Full Time</MenuItem>
                      <MenuItem value="part_time">Part Time</MenuItem>
                      <MenuItem value="contract">Contract</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Job Category</InputLabel>
                    <Select
                      name="job_category"
                      fullWidth
                      required
                      value={this.state.job_category}
                      onChange={this.handleInput}
                      style={{height: "45px"}}
                    >
                      <MenuItem value="">Select Category</MenuItem>
                      {this.state.allCategories.map((cat, index) => (
                        <MenuItem key={index} value={cat._id}>
                          {cat.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Salary Range"
                      name="salary_range"
                      fullWidth
                      required
                      onChange={this.handleInput}

                      style={{marginTop: "13px"}}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Urgent Hiring</InputLabel>
                    <Select
                      name="urgent_hiring"
                      fullWidth
                      value={this.state.urgent_hiring}
                      onChange={(e) =>
                        this.setState({ urgent_hiring: e.target.value })
                      }
                      style={{height: "45px"}}
                    >
                      <MenuItem value={false}>No</MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Job Description"
                      name="job_description"
                      fullWidth
                      multiline
                      rows={4}
                      required
                      onChange={this.handleInput}
                    />
                  </Grid>
                </Grid>

                <Grid mt={3}>
                  <MDButton
                    variant="contained"
                    color="info"
                    type="submit"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Creating..." : "Create Career"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="Pro-Rider Career"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
